function getApiKeyFromStorage() {
  //return $.cookie('APIKEY');
  return sessionStorage.getItem("apiKey");
}
function getApiTokenFromStorage() {
  //return $.cookie('AFFILIATETOKEN');
  return sessionStorage.getItem("apiToken");
}
